<div class="row">
  <div class="col-12">
    <h4 class="mt-0 text-center text-md-left" translate>ORDER</h4>
    <hr>
  </div>
  <div class="col-12">
    <lib-gung-settings-fortnox-order-confirmation></lib-gung-settings-fortnox-order-confirmation>
  </div>
  <div class="col-12">
    <lib-order-confirm-configuration></lib-order-confirm-configuration>
  </div>
  <div class="col-12 mt-3" *ngIf="orderConfirmConfig">
    <div class="d-flex justify-content-between align-items-baseline">
      <h5 class="mb-0 mt-0" translate>ORDER_DB_CONFIG</h5>
      <button class="btn btn-default" style="font-size: 20px;" (click)="saveOrderConfirmConfig()">
        <i ngbTooltip="{{'SAVE' | translate}}" class="fas fa-save"></i>
      </button>
    </div>
    <hr>
    <div class="row">
      <div class="col-12 col-md-6">
        <lib-gung-text-input
          gungTranslate="ORDER_CONFIRM_PDF_ATTACHMENT_NAME"
          [(ngModel)]="orderConfirmConfig.orderConfirmPdfAttachmentName"
          [placeholder]="'Ordererkännande - {orderId}'"
        ></lib-gung-text-input>
      </div>
      <div class="col-12 mt-2">
        <lib-gung-html-editor
          gungTranslate="ORDER_CONFIRM_BODY"
          [(ngModel)]="orderConfirmConfig.orderConfirmBody"
        ></lib-gung-html-editor>
      </div>
      <div class="col-12 mt-2">
        <lib-gung-html-editor
          gungTranslate="ORDER_CONFIRM_MAIL_SIGNATURE"
          [(ngModel)]="orderConfirmConfig.orderConfirmMailSignature"
        ></lib-gung-html-editor>
      </div>
    </div>
  </div>
</div>
